import clsx from "clsx";
import React from "react";
import {
  DialogProps,
  Button,
  Box,
  Link,
  Typography,
  Stack,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { BaseDialog } from "./BaseDialog";

const useStyles = makeStyles((theme) => ({
  root: {},

  paper: {
    maxWidth: 600,
  },

  actions: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },

  primaryButton: {
    width: "100%",
    fontWeight: "bold",
  },

  linkButton: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    fontWeight: 500,
    cursor: "pointer",
    fontFamily: "Montserrat, sans-serif",
    "&:hover": {
      textDecoration: "underline",
    },
  },

  dialogButton: {
    borderRadius: 4,
    fontSize: 16,
    fontWeight: "bold",
    flex: 1,
    height: theme.spacing(7),
  },

  description: {
    color: theme.palette.text.secondary,
    lineHeight: 1.6,
  },
}));

export interface CBADeactivationDialogProps extends Omit<DialogProps, "title"> {
  onCancel: () => void;
}

export function CBADeactivationDialog(props: CBADeactivationDialogProps) {
  const { className, onCancel, ...other } = props;
  const s = useStyles();

  const handleEmailSupport = React.useCallback(() => {
    window.location.href =
      "mailto:accounts@stridist.com?subject=Branded%20App%20Cancellation%20Request";
  }, []);

  return (
    <BaseDialog
      className={clsx(s.root, className)}
      title={"Cancel your branded app subscription"}
      onClose={onCancel}
      classes={{
        paper: s.paper,
      }}
      {...other}
    >
      <Stack gap={3}>
        <Typography className={s.description}>
          To cancel your branded app subscription, please contact our support
          team. They will assist you with the cancellation process and answer
          any questions you may have.
        </Typography>

        <Typography className={s.description}>
          You can reach us at{" "}
          <Link className={s.linkButton} href="mailto:accounts@stridist.com">
            accounts@stridist.com
          </Link>{" "}
          or click the button below to send us an email.
        </Typography>
      </Stack>

      <Box className={s.actions}>
        <Button
          variant="outlined"
          className={s.primaryButton}
          onClick={handleEmailSupport}
        >
          Contact support
        </Button>
      </Box>
    </BaseDialog>
  );
}
